<template>
	<div>
		<div class="train-list clearfix" :class="['train-list-' + mode_]">
			<div class="train-item" v-for="(item, index) in value" :key="index" @click="goDetail(item.id)">
				<div class="train-item__top">
					<img class="train-item__top_image poster-image" :src="item.attrs | imgUrl" />
					<div class="train-item__top_mask" v-if="mode_ === 1 || mode_ === 3">
						<p class="fr" v-if="mode_ === 1 || mode_ === 3">
							<img src="~@/assets/img/index/eyes-white.png" />
							<span>{{item.views}}</span>
						</p>
<!--						<span v-for="tag in item.contentTags" :key="tag.id">{{tag.tagName}}</span>-->
					</div>
				</div>
				<div class="train-item__title">{{item.title}}</div>
				<div class="train-btn-box" v-if="mode_ === 3">
					<button class="train-btn btn-sm" @click="goDetail(item.id)" :class="{'btn-gray': item.activityStatus === 4, 'btn-error': item.activityStatus === 3, 'btn-success': item.activityStatus === 2 || item.activityStatus === 1}">
						{{item.activityStatus === 4 ? '已结束' : (item.activityStatus === 3 ? '报名已满' : (item.activityStatus === 2 ? '直接前往' : '立即预约'))}}
					</button>
				</div>
			</div>
		</div>
		<!-- <ss-no-data v-if="finish && busy && value.length" /> -->
		<ss-no-data v-if="!finish && busy" text="数据加载中" />
		<ss-no-data v-else-if="finish && busy && value.length === 0" mode="image" text="暂无相关的信息" />
	</div>
</template>

<script>
	export default {
		props:{
			value: {
				type: Array,
				default: () => []
			},
			mode: {
				type: [String, Number],
				default: 1
			},
			detailPath: {
				type: [String, Boolean],
				// default: '/brilliantEHome/train/'
			},
			finish: {
				type: Boolean,
				default: false
			},
			busy: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			mode_() {
				return this.mode ? parseInt(this.mode) : 1;
			}
		},
		methods: {
			goDetail(id) {
				this.$emit('onClick', id)
				if(!this.detailPath) {
					console.log(this.mode, this.detailPath)
					if(this.mode && this.mode === '3') {
						this.detailPath = '/cultureAround/activity/'
					} else {
						this.detailPath = '/volunteerHome/elegantShow/'
					}
				}
				this.$router.push({
					path: this.detailPath + id
				})
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.train-list{
		overflow: hidden;
		// padding-right: 48px;
		&.train-list-3{
			// padding-right: 30px;
			.train-item{
				padding: 10px;
				border: 1px solid #DDDDDD;
				margin-right: 10px;
				&:nth-of-type(4n){
					margin-right: -30px;
				}
			}
			.train-item__top{
				height: 183px;
			}
			.train-btn-box{
				margin-top: 10px;
				.train-btn{
					border-radius: 8px;
				}
				.btn-sm{
					height: 32px;
					line-height: 32px;
					font-size: 14px;
				}
			}
		}
		.train-item{
			width: 24%;
			float: left;
			margin-bottom: 30px;
			margin-right: 1%;
			cursor: pointer;
			// &:nth-of-type(4n){
			// 	float: right;
			// 	margin-right: -48px;
			// }
			&:hover{
				.train-item__top_mask{
					background:rgba(1,95,253,.6);
				}
				.train-item__title{
					color: #0260FE;
				}
			}
		}
		.train-item__top{
			position: relative;
			width: 100%;
			height:196px;
			.train-item__top_image{
				width: 100%;
				height: 100% !important;
				display: block;
			}
		}
		.train-item__title{
			font-size:18px;
			font-weight:400;
			color:rgba(32,42,48,1);
			line-height:24px;
			margin-top: 10px;
			@include ellipsis();
		}
		.train-item__top_mask{
			padding: 0 10px;
			@include abs(null, 0, 0, 0);
			background:rgba(44,44,44,.6);
			line-height: 34px;
			@include tst();
			height: 34px;
			font-size:16px;
			font-weight:400;
			color:rgba(255,255,255,1);
			@include ellipsis();
			p{
				text-indent: 0!important;
			}
			img{
				width:15px;
				height:11px!important;
				display: inline-block;
			}
			span{
				display: inline-block;
				margin-left: 10px;
				color: #fff;
			}
		}
	}
</style>
